export default class GridLayoutToggle {
    constructor(element) {
        this.element = element;

        if (!this.element) return false;

        this.defaultColumnCount = Number(window.getComputedStyle(this.element).getPropertyValue('--grid-layout-column-count'));
        this.columnCountAlt = Number(this.element.dataset?.gridLayoutColumnCountAlt);
        this.context = this.element.closest('.js-grid-layout-toggle-context');
        this.control = this.context?.querySelector('.js-grid-layout-toggle-control');
        this.active = false;

        if (isNaN(this.defaultColumnCount) || isNaN(this.columnCountAlt) || !this.control) return false;

        this.init();
    }

    init () {
        this.control.addEventListener('click', () => {
            this.element.style.setProperty('--grid-layout-column-count', !this.active ? this.columnCountAlt : this.defaultColumnCount);
            this.element.style.setProperty('--grid-layout-item-span', !this.active ? this.defaultColumnCount : this.columnCountAlt);
            this.active = !this.active;

            this.control.classList.toggle('is-active', this.active);
            this.control.ariaPressed = this.active;
        });
    }
}
